import React, { ReactNode } from 'react';

import { AnalyticsData, AnalyticsEvents, AnalyticsTracking } from './Analytics';

interface AppStateProviderProps {
  children?: ReactNode
}

export interface AppStateContextProps {
  globalState: AppState
  analyticsDispatcher: React.Dispatch<{
    type: AnalyticsEvents;
    payload: any;
  }>
}

interface AppState {
  appEnv: string;
  aaProductName: string;
  aaBusinessUnit: string;
  aaLanguage: string;
  aaPageType: string;
  aaAnonymousVisitor: string;
  aaScriptUrl: string;

  analyticsData?: AnalyticsData;
}

const AppStateInstance = React.createContext<AppStateContextProps>({} as AppStateContextProps);
AppStateInstance.displayName = 'AppState';
export const useGlobalState = () => React.useContext(AppStateInstance);

const AppStateProvider = ({ children }: AppStateProviderProps) => {
  console.log('AppStateProvider');

  const [appState, setAppState] = React.useState({} as AppState);
  React.useEffect(() => {
    const abortController = new AbortController();
    if (process.env.NODE_ENV !== 'production') {
      console.log('App.tsx useEffect local');
      fetch("/env.json", {
        signal: abortController.signal,
      })
        .then((response) => response.json())
        .then((data) => { setAppState(data); })
        .catch((error) => console.error(error));
    } else {
      console.log('App.tsx useEffect prod');
      fetch("/env.json", {
        signal: abortController.signal,
      })
        .then((response) => response.json())
        .then((data) => { setAppState(data); })
        .catch((error) => console.error(error));
    }
    return () => {
      abortController.abort();
    };
  }, []);

  const [analyticsData, dispatcher] = React.useReducer(
    AnalyticsTracking.analyticsReducer,
    AnalyticsTracking.getInitialAnalyticsData(appState)
  );

  let props = useGlobalState();
  props.analyticsDispatcher = dispatcher;
  props.globalState = appState;
  props.globalState.analyticsData = analyticsData;
  if (props.globalState.aaAnonymousVisitor === undefined){
    console.log('AppStateProviderProps initialized - still loading env.json')
  } else {
    console.log('AppStateProviderProps initialized', props);
  }

  return (
    <AppStateInstance.Provider value={props}>{children}</AppStateInstance.Provider>
  );
};

export { AppStateProvider, AppStateInstance };
export type { AppState };
